export default __webpack_public_path__ + "static/media/medicaltest_detail_icon.1d33148a.svg";